import { UserRoles } from './user-roles';

export enum PermissionLevel {
  FULL_ACCESS = 'FULL_ACCESS',
  EDITOR = 'EDITOR',
  VIEWER = 'VIEWER',
}

export interface PermissionRolesProps {
  allowedRoles: UserRoles | UserRoles[];
  allowedPermissionLevels?: never;
}

export interface PermissionLevelProps {
  allowedRoles?: never;
  allowedPermissionLevels: PermissionLevel;
}

export type PermissionLevelsCatalog = {
  [key in PermissionLevel]: UserRoles[];
};
